import { ReactNode } from "react";

import styles from "./styles.module.css";

type HistoryTimelineProps = {
  children: ReactNode;
};

const HistoryTimeline = ({ children }: HistoryTimelineProps) => {
  return (
    // Safari/VoiceOver drops list semantics when list-style is none
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ol role="list" className={styles.wrapper}>
      {children}
    </ol>
  );
};

export default HistoryTimeline;
